















import axios from 'axios';
import { User } from '../../models/user';

import router from '../../routing/router'

import { Component, Prop, Vue } from 'vue-property-decorator';

import { mapGetters } from 'vuex'
import { Getter } from 'vuex-class'


@Component({
    name:'Logout',

    // Vuex bindings
    computed: mapGetters('account', [
        'loggedIn'
    ])
})

export default class Logout extends Vue {

    @Getter('account/loggedIn') loggedIn

    mounted() {
        this.logout();
    }

    logout() {
        if (this.loggedIn){
            this.$store.commit('account/logout')
        } else {
            this.$router.push({ path: '/auth/login' })
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/auth/Logout.vue